import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const StudentFocusSessionContext = createContext({
  focusSession: false,
  setFocusSession: () => {},
});

export function StudentFocusSessionProvider({ children }) {
  const [focusSession, setFocusSessionState] = useState(false);
  const setFocusSession = useCallback((v) => {
    setFocusSessionState(Boolean(v));
  }, []);

  const value = useMemo(
    () => ({ focusSession, setFocusSession }),
    [focusSession, setFocusSession]
  );

  return (
    <StudentFocusSessionContext.Provider value={value}>
      {children}
    </StudentFocusSessionContext.Provider>
  );
}

export function useStudentFocusSession() {
  return useContext(StudentFocusSessionContext);
}
